import React from "react";
import MultipleOfficesLP from "../MultipleOfficesLP";

function InnereMedizinDiabetologieLP() {
  var officeArray = [
    {
      doctorName: "Dipl. Med. Ines Ebenroth",
      doctorTitle:
        "FÄ für Innere Medizin / Diabetologin DDG Hausärztlich tätige Internistin / SPP Diabetologie",
      officeLoc: "Falkenberg/Elster",
      navLink: "/innere-medizin-diabetologie-ebenroth",
    },
    {
      doctorName: "Rebecca Kaupisch",
      doctorTitle: "FÄ für Innere Medizin / SPP Diabetologie",
      officeLoc: "Lauchhammer",
      navLink: "/innere-medizin-diabetologie-kaupisch",
    },
  ];

  return (
    <MultipleOfficesLP
      officeType={"Innere Medizin SP Diabetologie"}
      officeArray={officeArray}
    />
  );
}

export default InnereMedizinDiabetologieLP;
